import {
  Button,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react';
import { ReactNode, useState } from 'react';
import { WithFormControl } from '../WithFormControl';
import { PasswordInput } from '../PasswordInput';
import { t } from '@/i18n';

export interface ConfirmationPasswordModalProps extends Pick<ModalProps, 'isOpen' | 'onClose'> {
  onConfirm(): void;
  title?: ReactNode;
  description?: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  isLoading?: boolean;
}

export const ConfirmationPasswordModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = t('components.confirmation_password_modal.confirmation_password_modal_title'),
  description = t('components.confirmation_password_modal.confirmation_password_modal_description'),
  confirmLabel = t('components.confirmation_password_modal.confirmation_password_modal_confirm_label'),
  cancelLabel = t('components.confirmation_password_modal.confirmation_password_modal_cancel_label'),
  isLoading = false,
}: ConfirmationPasswordModalProps) => {
  const [password, setPassword] = useState('');

  const handlePasswordConfirmation = () => {
    // TODO: Verificar como vai funcionar confirmação de senha e validar corretamente
    if (password) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight='bold' mb='1rem'>
            {description}
          </Text>

          <WithFormControl variant='floating'>
            <PasswordInput
              variant='flushed'
              onChange={event => setPassword(event.target.value)}
              label={
                <FormLabel>{t('components.confirmation_password_modal.confirmation_password_modal_password_label')}</FormLabel>
              }
            />
          </WithFormControl>
        </ModalBody>

        <ModalFooter gap='kilo'>
          <Button variant='outlined' color='gray.600' onClick={onClose} isDisabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            backgroundColor='red.500'
            _hover={{ backgroundColor: 'red.600' }}
            onClick={handlePasswordConfirmation}
            isLoading={isLoading}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
